// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1071":"c167f724","1899":"c167f724","2908":"c167f724","5062":"e5fc220a","9002":"c167f724","9995":"c167f724"}[chunkId] + ".chunk.css";
};